var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarPhoneBoldDuotone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04994 6.67949L8.27794 6.45299C8.59294 6.13999 9.08344 6.07549 9.48644 6.29449L10.4414 6.81399C11.0549 7.14749 11.1904 7.96499 10.7109 8.44149L10.0009 9.14749C9.81994 9.32749 9.59594 9.45849 9.33794 9.48249C8.74194 9.53799 7.51544 9.50799 6.06844 8.66099L8.04994 6.67949ZM5.09494 3.74149L5.23844 3.59849C5.59194 3.24749 5.62544 2.68349 5.31694 2.27149L4.68694 1.42999C4.30494 0.91999 3.56744 0.85249 3.12994 1.28749L2.34494 2.06749C2.12844 2.28349 1.98344 2.56249 2.00094 2.87249C2.03344 3.44249 2.22744 4.48249 3.07544 5.76049L5.09494 3.74149Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.03144 5.74871C4.55844 4.28421 5.09144 3.74471 5.09494 3.74121L3.07544 5.76121C3.40894 6.26321 3.84294 6.80171 4.40744 7.36321C4.97744 7.93021 5.53744 8.35071 6.06844 8.66121L8.04994 6.68021C8.04994 6.68021 7.50894 7.21821 6.03144 5.74921",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPhoneBoldDuotone);
export default __webpack_public_path__ + "static/media/solar_phone-bold-duotone.496708e14b71fd708e007442a9e0e092.svg";
export { ForwardRef as ReactComponent };